"use strict";
/**
 * @module Session
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionToken = exports.TOKEN_LENGTH = void 0;
var uint8array_1 = require("./../util/uint8array");
/**
 * The buffer length os a session token
 */
exports.TOKEN_LENGTH = 24;
/**
 * A session token
 */
var SessionToken = /** @class */ (function () {
    /**
     * Create
     *
     * @param external The external buffer containing the token data
     */
    function SessionToken(external) {
        this.external = external;
    }
    /**
     * Convert the token to a string
     *
     * @return the string representation of the token
     */
    SessionToken.prototype.toString = function () {
        return uint8array_1.uint8ToAscii(this.external);
    };
    return SessionToken;
}());
exports.SessionToken = SessionToken;
